<template>
  <ul class="video-container">
    <li v-for="video in videos" :key="video.id" @click="navigateTo(video)">
      <div class="album">
        <div class="image">
          <img :src="video.firstFrame" alt="" />
        </div>
        <p>{{ video.duration | secondToDatetime }}</p>
        <img src="../../../assets/video/play_center@2x.png" alt="" />
      </div>
      <div class="info">
        <p class="title">{{ video.name }}</p>
        <div class="play">
          <img src="../../../assets/video/play@2x.png" alt="" />
          <p>{{ video.watchNum }}次播放</p>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import { secondToDatetime } from "@/utils/time";

export default {
  name: "VerticalLayoutVideo",
  props: {
    videos: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  filters: {
    secondToDatetime
  },
  methods: {
    navigateTo(video) {
      this.$router.push({
        name: "videoPlay",
        params: { id: video.id, video: video }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.video-container {
  > li {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 17px;
    border-radius: 6px;
    width: 100%;
    .album {
      position: relative;
      width: 100%;
      font-size: 0;
      .image {
        overflow: hidden;
        border-radius: 6px;
        width: 100%;
        height: 174px;
        background: #e4e4e4;
        img {
          width: 100%;
          height: 100%;
        }
      }
      > img:nth-of-type(1) {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
      }
      > p {
        position: absolute;
        bottom: 5px;
        right: 10px;
        font-size: 12px;
        font-weight: 400;
        color: #fff;
        line-height: 14px;
      }
    }
    .info {
      display: flex;
      justify-content: space-between;
      margin-top: 11px;
      width: 100%;
      text-align: left;
      .title {
        flex: 1;
        font-size: 15px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .play {
        margin-left: 10px;
        display: flex;
        align-items: center;
        > img {
          margin-right: 4px;
          width: 14px;
          height: 14px;
        }
        > p {
          font-size: 13px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 18px;
        }
      }
    }
  }
}
</style>
